export default __webpack_public_path__ + "static/media/Cedula.8161a627.png";